import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const WithGoogleReCaptcha = ({ children, apply }) => {
  return (
    apply ? (
      <GoogleReCaptchaProvider reCaptchaKey="6LfgZa4cAAAAAONsrLEzdHlGEztD-ONrHIs36G6W">
        {children}
      </GoogleReCaptchaProvider>
    ) : (
      children
    )
  );
};

export default WithGoogleReCaptcha